export enum VolumeUnitRaw {
  CUBIC_MM = 'mm',
  CUBIC_CM = 'cm',
  CUBIC_DM = 'dm',
  CUBIC_INCHES = 'in',
  CUBIC_FEET = 'ft',
  CUBIC_M = 'm',
}
